import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';
import { CreateGroupRequest, GroupResponse, UpdateGroupRequest } from '../models/groups.model';

@Injectable({ providedIn: 'root' })
export class GroupsApiService extends ApiService {
  getGroups$(): Observable<GroupResponse[]> {
    return this.get('/Groups');
  }

  createGroup$(request: CreateGroupRequest): Observable<GroupResponse> {
    return this.post('/Groups', request);
  }

  getGroup$(uniqueId: string): Observable<GroupResponse> {
    return this.get(`/Groups/${uniqueId}`);
  }

  updateGroup$(uniqueId: string, request: UpdateGroupRequest): Observable<GroupResponse> {
    return this.put(`/Groups/${uniqueId}`, request);
  }

  deleteGroup$(uniqueId: string): Observable<void> {
    return this.delete(`/Groups/${uniqueId}`);
  }
}

export const apiGroupsProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiGroups.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiGroups.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiGroups.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiGroups.scopes.write],
  },
];